import React from "react";
import { useNavigate, useParams } from "react-router-dom";
// ROUTER
import { withRouter } from "../../utils/withRouter";
// CANVAS
import AlertBanner from "canvas-core-react/lib/AlertBanner";
import Column from "canvas-core-react/lib/Column";
import TextBody from "canvas-core-react/lib/TextBody";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import Margin from "canvas-core-react/lib/Margin";
import TextHeadline from "canvas-core-react/lib/TextHeadline";

// COMPONENTS
import Layout from "../../components/Layout/Layout";
import Foot from "../../components/Layout/Foot";
import { ReactComponent as Icon } from '../../components/icons/icon_payment.svg';
import { ReactComponent as Icon_responsive } from '../../components/icons/icon_payment_responsive.svg';

// STYLES
import "./style.scss";
import LoadingIndicator from "canvas-core-react/lib/LoadingIndicator";

import { CE_DASHBOARD } from '../../constants/endpoints'
import resolveEnv from '../../Helpers/resolveEnv'
import { stepsTagging_3 } from "../../utils/tagging";
import RejectError from "../../components/errorComponents/RejectError";


const Payment = () => {
	const navigate = useNavigate();
	const iframe = React.useRef()
	const successUrl = window.location.origin + '/mfe/clsales/mfe-dap-new-client-web-cl/success'
	const { operationId } = useParams()
	const [investmentAmount, setInvestmentAmount] = React.useState('')
	const [form, setForm] = React.useState()

	const getForm = React.useCallback((operationId, successUrl) =>
		fetch(`${resolveEnv(CE_DASHBOARD)}/${operationId}`, {
			method: 'POST',
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ url_instance: successUrl }),
		})
			.then(a => {
				if (a.status >= 300)
					navigate('/reject-error');
				return a.json();
			})
			.catch(() => navigate('/reject-error'))
		, [])


	React.useEffect(() => {
		if (operationId && successUrl)
			getForm(operationId, successUrl)
				.then(response => {
					if (response) {
						const url = new URL(response.url_payment_button);
						setInvestmentAmount(response.investment_amount)
						setForm({
							action: url.origin + url.pathname,
							idClt: url.searchParams.get('id_clt'),
							data: url.searchParams.get('data').replace(/\s+/g, '+'),
							firma: url.searchParams.get('firma').replace(/\s+/g, '+'),
						})
					}
				})
				.catch(() => navigate('/reject-error'))
	}, [operationId, successUrl, getForm])

	React.useLayoutEffect(() => {
		if (iframe.current && form) {
			iframe.current.contentDocument.open()
			iframe.current.contentDocument.write(`<form action='${form.action}' method="post"><input type="hidden" name="id_clt" value='${form.idClt}' /><input type="hidden" name="data" value='${form.data}' /><input type="hidden" name="firma" value='${form.firma}' /></form>`)
			iframe.current.contentDocument.close()
			iframe.current.contentDocument.querySelector('form').submit()
		}
	}, [form])

	React.useEffect(() => {
		investmentAmount != '' && stepsTagging_3('rut', 'tipo', 'plazo', investmentAmount, 'tasa')
	}, [investmentAmount]);

	return (
		<>
			<Layout idBlackBanner={0} showBanner={false}>
				<Column lg={12} lgOffset={0}>
					{!investmentAmount ?
						<Margin side="both" lg={192} md={192} style={{ display: 'flex !important', justifyContent: 'center !important' }}>
							<LoadingIndicator
								accessibleTitle="Loading"
								size="large"
								className='LoadingCenter'
							/>
						</Margin>
						:
						<>
							<Column xsHide smHide>
								<Margin side="both" lg={24} md={24}>
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										<Icon />
									</div>
								</Margin>
							</Column>
							<Column lgHide mdHide>
								<Margin side="both" sm={24} xs={24}>
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										<Icon_responsive />
									</div>
								</Margin>
							</Column>
							<Margin side="bottom" lg={36}>
								<TextHeadline id="Payment_title_2" size="small" component="div">Realiza el pago de tu Depósito a Plazo</TextHeadline>
							</Margin>

							<TextBody id="Payment_subtitle" type="1" component="div">
								Ahora realizarás el pago del monto a invertir de tu Depósito a Plazo previamente simulado.<br />
								Luego de realizar el pago, todos tus productos contratados estarán disponibles.
							</TextBody>

							<TextHeadline id="Payment_title_2" component="div" style={{ color: '#7849B8' }}>
								<TextSubtitle type="1" component="div" style={{ paddingRight: '12px' }}>
									Monto a invertir
								</TextSubtitle>
								{investmentAmount}
							</TextHeadline>

							<Margin side="bottom" lg={30}>
								<TextSubtitle type="1" component="div">
									Elige tu banco para realizar el pago
								</TextSubtitle>
							</Margin>

							<Margin side="top" lg={18}>
								<iframe
									title="1"
									height="120"
									width="100%"
									src="about:blank"
									ref={iframe}
								/>
							</Margin>

							<Column lg={11} lgOffset={0.5}>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<AlertBanner type="info" id="Payment_alertBanner" style={{ marginBottom: "-12px" }}>
										Tu <b>Depósito a Plazo se hará efectivo </b>una vez que el
										pago total del monto se haya realizado de forma exitosa.
									</AlertBanner>
								</div>
							</Column>
						</>}
				</Column>
			</Layout>
			<Foot />
		</>
	);
}

export default withRouter(Payment);